export const mapCollectionDetails = (omekaData: any, foreas_en_title: string) => {
  const collectionTitle = omekaData?.['collections:collectionsTitle']?.map((item: any) => item?.['@value']);
  const collectionTitleEN = omekaData?.['collections:collectionsEnTitle']?.map((item: any) => item?.['@value']);
  const collectionDescription = omekaData?.['collections:collectionsDescription']?.map((item: any) => item?.['@value']);
  const collectionDescriptionEN = omekaData?.['collections:collectionEnDescription']?.map((item: any) => item?.['@value']);
  const collectionId = omekaData?.['collections:collectionsIdentifierUniqueCode']?.map((item: any) => item?.['@value']);
  const collectionOrganisation = omekaData?.['collections:collectionsRelateOrganisation']?.map((item: any) => item?.['display_title']);
  const collectionOrganisationResourceId = omekaData?.['collections:collectionsRelateOrganisation']?.map((item: any) => item?.['value_resource_id']);
  const collectionRelateOrg = omekaData?.['collections:collectionsRelateOrganisation']?.map((item: any) => item?.['display_title']);
  const collectionRelateDocument = omekaData?.['collections:collectionsRelateDocument']?.map((item: any) => item?.['@value']);
  const collectionRelateDocumentResourceId = omekaData?.['collections:collectionsRelateDocument']?.map((item: any) => item?.['value_resource_id']);
  const collectionsComments = omekaData?.['collections:collectionsComments']?.[0]?.['@value'];
  const collectionsCommentsEn = omekaData?.['collections:collectionsCommentsEn']?.[0]?.['@value'];
  const collectionOrganisationEn = foreas_en_title;

  return {
    collectionTitle,
    collectionTitleEN,
    collectionDescription,
    collectionDescriptionEN,
    collectionOrganisation,
    collectionRelateOrg,
    collectionRelateDocument,
    collectionId,
    collectionsComments,
    collectionsCommentsEn,
    collectionOrganisationResourceId,
    collectionOrganisationEn,
    collectionRelateDocumentResourceId
  };
};

export const collectionDetails = (fetchData: any) => {
  return fetchData.reverse['documents:documentsRelationCollection'].data.map((x: any) => {
    return {
      id: x['o:id'],
      title: x['documents:documentsTitle']?.map((item: any) => item?.['@value'])[0],
      type: x['documents:documentsType']?.map((item: any) => item?.['@value'])[0],
      relateCollection: x['documents:documentsRelationCollection']?.map((item: any) => item?.['display_title']),
      relateOrganisation: x['documents:documentsRelationOrganisation']?.map((item: any) => item?.['display_title']),
      url: `/search-documents/details/${x['o:id']}` 
    };
  });
};